/**
 * @generated SignedSource<<ef2d4b8da5c229711b0b19fd50961cc7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type labelGroupHeader_issueTableGrouping$data = {
  readonly label: {
    readonly color: {
      readonly colorKey: string | null | undefined;
    } | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "labelGroupHeader_issueTableGrouping";
};
export type labelGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: labelGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"labelGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "labelGroupHeader_issueTableGrouping",
  "selections": [
    {
      "concreteType": "JiraLabel",
      "kind": "LinkedField",
      "name": "label",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "concreteType": "JiraColor",
          "kind": "LinkedField",
          "name": "color",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "colorKey"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraJqlLabelFieldValue"
};

(node as any).hash = "5799ec916c3b3253f43da10a011536b1";

export default node;
